var _filter, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgWave3InvertedShadow = function SvgWave3InvertedShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 200",
    filter: "url(#wave-3-inverted-shadow_svg__a)",
    enableBackground: "new 0 0 1600 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "wave-3-inverted-shadow_svg__a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1413.6 39.3c-157.9 0-338.2 37.7-495.1 67.4-215.6 40.8-328.1 44.6-418.2 41.1S317 127.3 188.4 98.7C59.8 70.1-10 64.5-10 64.5v10s69.8 5.6 198.4 34.2c128.6 28.6 221.8 45.6 311.9 49.1s202.6-.3 418.2-41.1c156.9-29.7 337.2-67.4 495.1-67.4 127.6 0 196.4 19.5 196.4 19.5v-10s-68.8-19.5-196.4-19.5z"
  })));
};
export default SvgWave3InvertedShadow;